import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=35929577&scoped=true"
import script from "./Authorization.vue?vue&type=script&lang=js"
export * from "./Authorization.vue?vue&type=script&lang=js"
import style0 from "./Authorization.vue?vue&type=style&index=0&id=35929577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35929577",
  null
  
)

export default component.exports